import { useEffect, useMemo, useState } from 'react'
import {
  showLoadingBox,
  hideLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import * as StepHttp from '../../../../../services/api/https/deliveries/delivery-step.http'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import * as SifHttp from '../../../../../services/api/https/registration/sif-unit.http'

const INITIAL_STATE = {
  loading: true,
  btnLoading: false,
  globalFilter: '',
  selecionarTodos: false,
  shouldNotRender: false,

  identificadores: [],
  items: [],
  itemsFiltrados: [],

  sifOptions: [],
  selectedSif: null,

  ocOptions: [],
  selectedOc: null,

  dcpoaText: '',

  tpId: null,
  companyId: null,
}

function pickValue(e) {
  if (e && typeof e === 'object') {
    if (Object.prototype.hasOwnProperty.call(e, 'value')) return e.value
    if (e.target) return e.target.value
  }
  return e
}

export default function useEntradaSIFState(ciclo, dispatch) {
  const [state, setState] = useState(INITIAL_STATE)

  useEffect(function () {
    init()
  }, [])

  async function init() {
    try {
      dispatch(showLoadingBox('Carregando dados', 'Aguarde...'))

      var cicloId = null
      var companyId = null

      if (ciclo) {
        cicloId = ciclo.id
          ? ciclo.id
          : ciclo.cycle_id
            ? ciclo.cycle_id
            : ciclo.cicloId
              ? ciclo.cicloId
              : null
        if (ciclo.company && ciclo.company.id) {
          companyId = ciclo.company.id
        } else if (ciclo.company_id) {
          companyId = ciclo.company_id
        } else if (ciclo.empresaId) {
          companyId = ciclo.empresaId
        }
      }

      if (!cicloId || !companyId) {
        dispatch(hideLoadingBox())
        dispatch(
          showMessageBox(
            null,
            'Erro ao localizar o ciclo/empresa. Volte e selecione novamente o ciclo.',
          ),
        )
        setState(function (prev) {
          return { ...prev, loading: false, shouldNotRender: true }
        })
        return
      }

      // Validar tipo do ciclo (recebimento)
      var tipo = null
      if (ciclo && ciclo.type) tipo = String(ciclo.type).toLowerCase()
      if (!['recebimento', 'recebimento-de-para'].includes(tipo)) {
        dispatch(hideLoadingBox())
        dispatch(
          showMessageBox(
            null,
            'Essa ação está disponível apenas para ciclos do tipo Recebimento - Estoque ',
          ),
        )
        setState(function (prev) {
          return { ...prev, loading: false, shouldNotRender: true }
        })
        return
      }

      // Buscar entregas com steps do ciclo
      const stepsResp = await StepHttp.getDeliveriesWithStepsByCycle(cicloId)
      const entregas = Array.isArray(stepsResp) ? stepsResp : []
      if (entregas.length === 0) {
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(null, 'Associe o trecho das entregas para acessar essa ação'))
        setState(function (prev) {
          return { ...prev, loading: false, shouldNotRender: true }
        })
        return
      }

      // Todas as entregas com trecho 1
      var allHaveStep1 = true
      for (var i = 0; i < entregas.length; i++) {
        var e = entregas[i]
        if (!Array.isArray(e.steps) || e.steps.length === 0 || Number(e.steps[0].step) !== 1) {
          allHaveStep1 = false
          break
        }
      }
      if (!allHaveStep1) {
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(null, 'Associe o trecho das entregas para acessar essa ação'))
        setState(function (prev) {
          return { ...prev, loading: false, shouldNotRender: true }
        })
        return
      }

      // Todas as entregas apontando para o mesmo tp_id
      var tpSet = {}
      for (var j = 0; j < entregas.length; j++) {
        var ej = entregas[j]
        var tp = ej.steps[0].tp_id
        tpSet[String(tp)] = true
      }
      var tpIds = Object.keys(tpSet).map(function (k) {
        return Number(k)
      })
      if (tpIds.length !== 1) {
        dispatch(hideLoadingBox())
        dispatch(
          showMessageBox(
            null,
            'Todos os identificadores devem estar associados ao mesmo trecho inicial',
          ),
        )
        setState(function (prev) {
          return { ...prev, loading: false, shouldNotRender: true }
        })
        return
      }
      var tpId = tpIds[0]

      // Identificadores
      var identificadoresSet = {}
      for (var k = 0; k < entregas.length; k++) {
        var ek = entregas[k]
        if (ek.identifier) identificadoresSet[String(ek.identifier).trim()] = true
      }
      var identificadores = Object.keys(identificadoresSet)

      // Dropdowns: SIFs ativas da company
      const sifs = await SifHttp.getSifUnitsActived(companyId)
      const sifOptions = (Array.isArray(sifs) ? sifs : []).map(function (s) {
        return {
          id: s.id,
          value: s.id,
          label:
            (s.inspection_service ? s.inspection_service : '') +
            ' ' +
            (s.sif_code ? s.sif_code : '') +
            ' - ' +
            (s.unit_name ? s.unit_name : '') +
            ' - ' +
            (s.unit_type ? s.unit_type : ''),
          raw: s,
        }
      })

      // Dropdowns: OCs "Não Associada" do TP+company
      const ocs = await EstoqueHttp.getOcPrevistasNotAssociated(tpId, companyId)
      const ocOptions = (Array.isArray(ocs) ? ocs : []).map(function (o) {
        var prefix = o.oc_code ? o.oc_code + ' - ' : ''
        return {
          id: o.id,
          value: o.id,
          label: prefix + (o.destino ? o.destino : ''),
          raw: o,
        }
      })

      // Itens (Produtos) do ciclo
      const itemsResp = await CicloEntregaAcoesHttp.getDeliveryItemsByCycle(cicloId)
      const items = (Array.isArray(itemsResp) ? itemsResp : []).map(function (r) {
        const sifOpt = (sifOptions || []).find(o => o.id === r.sif_unit_id)
        const ocOpt = (ocOptions || []).find(o => o.id === r.estoque_ordem_carregamento_prevista_id)

        const sifLabelInicial =
          r.sif_name && String(r.sif_name).trim().length > 0
            ? String(r.sif_name).trim()
            : sifOpt
              ? sifOpt.label
              : ''

        const ocLabelInicial =
          r.eoc_name && String(r.eoc_name).trim().length > 0
            ? String(r.eoc_name).trim()
            : ocOpt
              ? ocOpt.label
              : ''

        return {
          id: r.id,
          delivery_id: r.delivery_id,
          identifier: r.identifier,
          product_id: r.product_id,
          product_code: r.product_code,
          product_name: r.product_name,
          qte_total: r.qte_total,
          selected: false,
          sif_id: r.sif_unit_id != null ? r.sif_unit_id : null,
          oc_id:
            r.estoque_ordem_carregamento_prevista_id != null
              ? r.estoque_ordem_carregamento_prevista_id
              : null,
          dcpoa: r.dcpoa != null ? r.dcpoa : '',
          sif_label: sifLabelInicial,
          oc_label: ocLabelInicial,
        }
      })

      setState(function (prev) {
        return {
          ...prev,
          loading: false,
          identificadores: identificadores,
          sifOptions: sifOptions,
          ocOptions: ocOptions,
          items: items,
          itemsFiltrados: items,
          tpId: tpId,
          companyId: companyId,
        }
      })
    } catch (error) {
      dispatch(showMessageBox(null, String(error && error.message ? error.message : error)))
      setState(function (prev) {
        return { ...prev, loading: false, shouldNotRender: true }
      })
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  function setGlobalFilter(value) {
    var v = pickValue(value)
    setState(function (prev) {
      var filtro = v ? String(v).toLowerCase() : ''
      var filtrados = filtro
        ? prev.items.filter(function (i) {
            return (
              String(i.identifier).toLowerCase().indexOf(filtro) >= 0 ||
              String(i.product_code).toLowerCase().indexOf(filtro) >= 0 ||
              String(i.product_name).toLowerCase().indexOf(filtro) >= 0
            )
          })
        : prev.items
      return { ...prev, globalFilter: v, itemsFiltrados: filtrados }
    })
  }

  function toggleSelecionarTodos(checked) {
    setState(function (prev) {
      function mapSel(arr) {
        return arr.map(function (i) {
          return { ...i, selected: checked }
        })
      }
      return {
        ...prev,
        selecionarTodos: checked,
        items: mapSel(prev.items),
        itemsFiltrados: mapSel(prev.itemsFiltrados),
      }
    })
  }

  function toggleSelecionado(item, checked) {
    setState(function (prev) {
      function upd(arr) {
        return arr.map(function (i) {
          return i.id === item.id ? { ...i, selected: checked } : i
        })
      }
      return { ...prev, items: upd(prev.items), itemsFiltrados: upd(prev.itemsFiltrados) }
    })
  }

  function setSelectedSif(e) {
    var opt = e && e.value ? e.value : e
    var found = null
    for (var i = 0; i < state.sifOptions.length; i++) {
      var o = state.sifOptions[i]
      if (o.value === opt || o.id === opt || o === opt) {
        found = o
        break
      }
    }
    setState(function (p) {
      return { ...p, selectedSif: found }
    })
  }

  function setSelectedOc(e) {
    var opt = e && e.value ? e.value : e
    var found = null
    for (var i = 0; i < state.ocOptions.length; i++) {
      var o = state.ocOptions[i]
      if (o.value === opt || o.id === opt || o === opt) {
        found = o
        break
      }
    }
    setState(function (p) {
      return { ...p, selectedOc: found }
    })
  }

  function setDcpoaText(value) {
    var v = pickValue(value)
    setState(function (p) {
      return { ...p, dcpoaText: v }
    })
  }

  function assertHasSelection() {
    var selected = []
    for (var i = 0; i < state.items.length; i++) {
      if (state.items[i].selected) selected.push(state.items[i])
    }
    if (selected.length === 0) throw new Error('Selecione pelo menos um produto na tabela.')
    return selected
  }

  function associarSif() {
    try {
      if (!state.selectedSif) throw new Error('Selecione uma S.I.F antes de associar.')
      assertHasSelection()
      var sif_id = state.selectedSif.value
      var label = state.selectedSif.label
      setState(function (prev) {
        function upd(arr) {
          return arr.map(function (i) {
            return i.selected ? { ...i, sif_id: sif_id, sif_label: label } : i
          })
        }
        return { ...prev, items: upd(prev.items), itemsFiltrados: upd(prev.itemsFiltrados) }
      })
    } catch (error) {
      dispatch(showMessageBox(null, String(error && error.message ? error.message : error)))
    }
  }

  function associarOc() {
    try {
      if (!state.selectedOc)
        throw new Error('Selecione uma Ordem de Carregamento antes de associar.')
      assertHasSelection()
      var oc_id = state.selectedOc.value
      var label = state.selectedOc.label
      setState(function (prev) {
        function upd(arr) {
          return arr.map(function (i) {
            return i.selected ? { ...i, oc_id: oc_id, oc_label: label } : i
          })
        }
        return { ...prev, items: upd(prev.items), itemsFiltrados: upd(prev.itemsFiltrados) }
      })
    } catch (error) {
      dispatch(showMessageBox(null, String(error && error.message ? error.message : error)))
    }
  }

  function associarDcpoa() {
    try {
      var dcpoa = String(state.dcpoaText ? state.dcpoaText : '').trim()
      if (!dcpoa) throw new Error('Digite um D.C.P.O.A antes de associar.')
      assertHasSelection()
      setState(function (prev) {
        function upd(arr) {
          return arr.map(function (i) {
            return i.selected ? { ...i, dcpoa: dcpoa } : i
          })
        }
        return { ...prev, items: upd(prev.items), itemsFiltrados: upd(prev.itemsFiltrados) }
      })
    } catch (error) {
      dispatch(showMessageBox(null, String(error && error.message ? error.message : error)))
    }
  }

  async function salvar() {
    try {
      const payload = []
      for (const it of state.items) {
        const has = it.sif_id || it.oc_id || (it.dcpoa && it.dcpoa.length > 0)
        if (it.selected && has) {
          payload.push({
            delivery_item_id: it.id,
            sif_unit_id: it.sif_id != null ? it.sif_id : null,
            oc_prevista_id: it.oc_id != null ? it.oc_id : null,
            dcpoa: it.dcpoa ? String(it.dcpoa).trim() : null,
          })
        }
      }

      if (payload.length === 0) {
        dispatch(showMessageBox(null, 'Faça pelo menos uma associação antes de Salvar'))
        return
      }

      dispatch(showLoadingBox('Salvando associações', 'Aguarde...'))
      await CicloEntregaAcoesHttp.saveEntradaSif(payload)

      const ocs = await EstoqueHttp.getOcPrevistasNotAssociated(state.tpId, state.companyId)
      const ocOptions = (Array.isArray(ocs) ? ocs : []).map(function (o) {
        var prefix = o.oc_code ? o.oc_code + ' - ' : ''
        return { id: o.id, value: o.id, label: prefix + (o.destino ? o.destino : ''), raw: o }
      })

      setState(function (prev) {
        const items = prev.items.map(i => ({ ...i, selected: false }))
        return { ...prev, ocOptions, items, itemsFiltrados: items }
      })

      dispatch(hideLoadingBox())
      dispatch(showMessageBox('Associações salvas com sucesso!', null))
    } catch (error) {
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(null, String(error && error.message ? error.message : error)))
    }
  }

  const localDispatch = useMemo(
    function () {
      return {
        init,
        setGlobalFilter,
        toggleSelecionarTodos,
        toggleSelecionado,
        setSelectedSif,
        setSelectedOc,
        setDcpoaText,
        associarSif,
        associarOc,
        associarDcpoa,
        salvar,
      }
    },
    [state],
  )

  return { state, localDispatch }
}
